import type { FC } from 'react';
import { Box } from '@mui/material';

import { Loader } from '../../';

export const PageLoadingIndicator: FC = () => {
	return (
		<Box
			sx={{
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)',
			}}
		>
			<Loader delay={100} />
		</Box>
	);
};
